import { Link } from "gatsby"
import * as React from "react"
import styled, { css } from "styled-components"
import { IconChevronDown, IconChevronUp } from "styleguide/icons"
import { uiColorToBaseColor } from "styleguide/styles/colors"

interface Props {
  to?: string
  title: string
  withChevron: boolean
  isOpen: boolean
  onClick?: () => void
  onMouseOver?: any // TODO: extend styled Link
  isCurrent?: boolean
  externalLink?: boolean
}

const StyledLink = styled(({ component, ...props }) =>
  React.cloneElement(component, props)
)`
  color: ${uiColorToBaseColor("darkestGray")};
  font-weight: 700;
  font-size: 16px;
  text-decoration: none;

  svg {
    margin-left: 5px;
  }

  &:hover {
    color: ${uiColorToBaseColor("darkerRed")};
  }
`

const Title = styled.span<{ isCurrent: boolean }>`
  position: relative;

  ${props =>
    props.isCurrent &&
    css`
      color: ${uiColorToBaseColor("darkerRed")};
      &:after {
        position: absolute;
        content: "";
        height: 4px;
        width: 16px;
        background-color: #ee2b16;
        border-radius: 2px;
        margin: 0 auto;
        left: 0;
        right: 0;
        bottom: -12px;
      }
    `}
`

const MenuLinkTitle = ({
  to,
  title,
  withChevron = false,
  isOpen = false,
  onClick,
  isCurrent = false,
  externalLink = false,
  ...otherProps
}: Props) => {
  const showChevronUp = withChevron && isOpen
  const showChevronDown = withChevron && !isOpen

  const handleOnClick = () => {
    if (onClick) {
      onClick()
    }
  }
  /* eslint-disable jsx-a11y/anchor-has-content */
  return (
    <StyledLink
      onClick={handleOnClick}
      component={
        to ? ( // eslint-disable-line no-nested-ternary
          externalLink ? (
            <a href={to} target="_blank" rel="noopener" />
          ) : (
            <Link to={to} />
          )
        ) : (
          <span />
        )
      }
      {...otherProps}
    >
      <Title isCurrent={isCurrent}>{title}</Title>
      {showChevronUp && <IconChevronUp size="xxs" />}
      {showChevronDown && <IconChevronDown size="xxs" />}
    </StyledLink>
  )
  /* eslint-enable jsx-a11y/anchor-has-content */
}

export default MenuLinkTitle
